import React, { useState, useEffect } from "react";
import {
  Modal,
  Form,
  Input,
  Select,
  Button,
  message,
  Space,
  Tooltip,
  Table,
  Checkbox,
  DatePicker,
} from "antd";
import {
  SaveOutlined,
  EditOutlined,
  CloseOutlined,
  BankOutlined,
  HomeOutlined,
  SearchOutlined,
  GlobalOutlined,
} from "@ant-design/icons";
import axios from "axios";
import { BE_HOST } from "../../config/config";
import { axiosInstance } from "../../utils/axiosInterceptor";
import "./profile.css";
import moment from "moment";
import dayjs from "dayjs";
import { ContactsDummyData, subscriptionDummyData } from "../../data";

const subscriptionData = [
  {
    id: 1,
    label: "Dashboard",
    status: "Yes",
  },
  {
    id: 2,
    label: "CPT",
    status: "No",
  },
  {
    id: 1,
    label: "Management Dashboard",
    status: "Yes",
  },
  {
    id: 1,
    label: "AI Modules",
    status: "No",
  },
];
const AccountPopup = ({
  popupWithScrollViewVisible,
  hide,
  data,
  isNewRecord,
  onSuccess,
}) => {
  const [form] = Form.useForm();
  // const isNewRecord = !data;
  const [loading, setLoading] = useState(false);
  const [accountsData, setAccountsData] = useState([]);
  const [selectedAccounts, setSelectedAccounts] = useState([]);
  const [editMode, setEditMode] = useState(false);
  const [filterData, setFilterData] = useState([]);
  const token = localStorage.getItem("token");
  const [gpoData, setGpoData] = useState([]);
  const [wholeSalerData, setWholeSalerData] = useState([]);
  const [isEditMode, setIsEditMode] = useState(false);
  const [editableData, setEditableData] = useState([]);
  const [editWholeSale, setEditWholeSale] = useState(false);
  const [subsData, setSubsData] = useState([]);
  const [editSubsCription, setEditSubsCription] = useState(false);
  const displayData =
    subsData && subsData.length > 0
      ? subsData
      : subscriptionDummyData.map((item) => ({ ...item }));

  // Update the column structure for users
  const accountColumns = [
    {
      title: "First Name",
      dataIndex: "first_name",
      key: "first_name",
      render: (text) => text || "-",
      ellipsis: true,
      width: 150,
    },
    {
      title: "Middle Name",
      dataIndex: "middle_name",
      key: "middle_name",
      render: (text) => text || "-",
      ellipsis: true,
      width: 150,
    },
    {
      title: "Last Name",
      dataIndex: "last_name",
      key: "last_name",
      render: (text) => text || "-",
      ellipsis: true,
      width: 150,
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      render: (text) => text || "-",
      ellipsis: true,
      width: 200,
    },
  ];
  const userDetails = JSON.parse(localStorage.getItem("userDetails") || null);
  // Add this state for search
  const [searchText, setSearchText] = useState("");
  // Add this function to filter accounts
  const filteredAccounts = accountsData?.filter(
    (account) =>
      account.email?.toLowerCase().includes(searchText.toLowerCase()) ||
      `${account.first_name} ${account.last_name}`
        ?.toString()
        .toLowerCase()
        .includes(searchText.toLowerCase()),
  );

  const handleSearch = (value) => {
    // console.log(value, "Value");
    setSearchText(value);
    const searchVal = value.toLowerCase();
    const filtered = accountsData?.filter(
      (account) =>
        account.email?.toLowerCase().includes(searchText.toLowerCase()) ||
        `${account.first_name} ${account.last_name}`
          ?.toString()
          .toLowerCase()
          .includes(searchText.toLowerCase()),
    );
    setFilterData(filtered);
  };

  const [userMappedAccounts, setUserMappedAccounts] = useState([]);
  // Update fetchAccountsData to also fetch user's mapped accounts
  // Update fetchAccountsData to handle new and edit cases differently
  const fetchAccountsData = React.useCallback(async () => {
    setLoading(true);
    try {
      // if (isNewRecord) {
      // For new record, only fetch all users
      const response = await axiosInstance.get(`api/v2/account/all`, {
        // headers: { Authorization: `Bearer ${token}` },
      });
      setAccountsData(response?.data?.data);
      setFilterData(response?.data?.data);
      setSelectedAccounts([]);
      setUserMappedAccounts([]);

      if (!isNewRecord) {
        const mappedUsersResponse = await axiosInstance.get(
          `${BE_HOST}/account/users-by-account?accountNumber=${data.acct_id}`,
        );

        const mappedUsers = mappedUsersResponse.data?.data?.data || [];
        setSelectedAccounts(mappedUsers.map((user) => user.id));
        setUserMappedAccounts(mappedUsers);
      } else {
        setSelectedAccounts([]);
        setUserMappedAccounts([]);
      }
      // // }
      // // else {
      //   // For edit, fetch both all users and mapped users
      //   const [, mappedUsersResponse] = await Promise.all([
      //     axiosInstance.get(`${BE_HOST}/users/all`, {
      //       headers: { Authorization: token },
      //     }),
      //     axiosInstance.get(
      //       `${BE_HOST}/account/users-by-account?accountNumber=${data.acct_id}`,
      //       {
      //         headers: { Authorization: token },
      //       }
      //     ),
      //   ]);
      //   // setAccountsData(allUsersResponse.data[0]);
      //   const mappedUsers = mappedUsersResponse.data.data.data || [];
      //   setSelectedAccounts(mappedUsers.map((user) => user.id));
      //   setUserMappedAccounts(mappedUsersResponse.data.data.data);
      // // }
    } catch (error) {
      console.error("Error fetching data:", error);
      message.error("Failed to fetch users data");
      setAccountsData([]);
      setSelectedAccounts([]);
      setFilterData([]);
      setUserMappedAccounts([]);
    } finally {
      setLoading(false);
    }
  }, [token, data, isNewRecord]);

  useEffect(() => {
    if (popupWithScrollViewVisible) {
      if (data) {
        form.setFieldsValue(data);
        getGpoData();
        getWholeSalerData();
        getSubsription();
      } else {
        form.resetFields();
      }
      fetchAccountsData();
    } else {
      setEditMode(false); // Reset editMode when popup is closed
      setEditSubsCription(false);
      setEditWholeSale(false);
      setIsEditMode(false);
    }
  }, [popupWithScrollViewVisible, data, form, fetchAccountsData]); // added dependency fetchAccountsData

  const handleCancel = () => {
    form.resetFields();
    setEditMode(false);
    setSelectedAccounts([]);
    setEditSubsCription(false);
    setEditWholeSale(false);
    setIsEditMode(false);
    hide();
  };

  const getGpoData = async () => {
    try {
      const response = await axiosInstance.get(
        `api/v2/account/accounts-gpo-ipc?accountNumber=${data?.acct_id}`,
      );
      // console.log(response, "Respnse");
      // setGpoData(response?.data?.data);
      // setEditableData(response?.data?.data);
      const formattedData = response?.data?.data?.map((account) => ({
        ...account,
        gpos: {
          ...account?.gpos,
          contacts:
            account?.gpos?.contacts?.length > 0
              ? account.gpos.contacts
              : [...ContactsDummyData],
        },
      }));
      setGpoData(formattedData);
      setEditableData(formattedData);
    } catch (error) {
      console.log(error, "Error");
    } finally {
    }
  };
  const getWholeSalerData = async () => {
    try {
      const response = await axiosInstance.get(
        `api/v2/account/accounts-with-wholesaler?accountNumber=${data?.acct_id}`,
      );
      // console.log(response?.data?.data, "Respnsewholse");
      // setWholeSalerData(response?.data?.data);
      const res = response?.data;
      const formattedData = res?.data?.map((account) => ({
        ...account,
        wholesalers: account?.wholesalers?.map((wholesaler) => ({
          ...wholesaler,
          contacts:
            wholesaler?.contacts?.length > 0
              ? wholesaler.contacts
              : [...ContactsDummyData],
        })),
      }));

      setWholeSalerData(formattedData);
    } catch (error) {
      console.log(error, "Error");
    } finally {
    }
  };
  const getSubsription = async () => {
    try {
      const response = await axiosInstance.get(
        `api/v2/account/get-subscription?accountNumber=${data?.acct_id}`,
      );
      if (response?.data?.data?.length > 0) {
        setSubsData(response.data.data);
      } else {
        setSubsData([]);
      }
      // setSubsData(response?.data?.data);
    } catch (error) {
      console.log(error, "Error");
    } finally {
    }
  };

  const handleSaveAccounts = async () => {
    try {
      const selectedUserIds = selectedAccounts;

      // const previouslyMappedIds = userMappedAccounts.map((user) => user.id);
      const selectedAccountsData = accountsData?.filter((account) =>
        selectedUserIds.includes(account.id),
      );
      if (selectedAccountsData.length > 0) {
        const res = await axiosInstance.post(
          `/account/map-users-to-account`,
          {
            // login_userId: userDetails.data.modify_user_id,
            accountId: data?.id || null,
            userIds: selectedUserIds,

            // userId: data?.id || null,
            // // Send the selected account ids
            // accountIds: selectedAccounts,
          },
          // {
          //   headers: {
          //     "Content-Type": "application/json",
          //     Authorization: `Bearer ${token}`,
          //   },
          // }
        );
        if (res) {
          message.success("Users mapping updated successfully");
          setEditMode(false);
          await fetchAccountsData();
        }
      } else {
        setEditMode(false);
      }
    } catch (error) {
      console.error("Error mapping users:", error);
      message.error("Failed to update user mapping");
    }
  };

  const handleSubmit = async (values) => {
    try {
      const token = localStorage.getItem("token");
      // Convert values to proper types
      const formData = {
        ...values,
        account_type: Number(values.account_type),
        // rebate_types_id: Number(values.rebate_types_id),
      };

      if (isNewRecord) {
        await axiosInstance.post(`/account/create`, formData, {
          // headers: { Authorization: `Bearer ${token}` },
        });
        message.success("Account created successfully");
      } else if (!!editMode) {
        message.info("Please first save changes");
        return;
      } else {
        await axiosInstance.put(`api/v2/account/update/${data.id}`, formData, {
          // headers: { Authorization: `Bearer ${token}` },
        });
        message.success("Account updated successfully");
      }
      onSuccess();
    } catch (error) {
      message.error("Operation failed");
      console.error("Error:", error);
    }
  };
  const UpdateSubscription = async () => {
    const Newpayload = subsData?.map(
      ({ module_name, is_active, expiry_date }) => ({
        module_name,
        is_active,
        expiry_date,
      }),
    );
    const payload = {
      account_id: data?.acct_id,
      subscriptions: Newpayload,
    };
    try {
      const response = await axiosInstance.post(
        `api/v2/account/set-subscription`,
        payload,
      );
      console.log(response, "response");
      setEditSubsCription(false);
      message.success(response?.data?.message);
      getSubsription();
    } catch (error) {
      console.log(error, "Error");
      message.error(error?.response?.data?.message);
    }
  };
  const updatePMWholeSaler = async () => {
    try {
      const account = wholeSalerData?.[0];
      const wholesaler = account?.wholesalers?.[0];

      const payload = {
        acct_id: account?.acct_id,
        wholesaler_code: wholesaler?.code,
        contacts: wholesaler?.contacts?.map((c) => ({
          type: c?.type,
          name: c?.name,
          email: c?.email,
          title: c?.title,
          phone: c?.phone,
          smsFlag: c?.smsFlag,
        })),
      };
      setEditWholeSale(false);
      const response = await axiosInstance.put(
        "api/v2/account/accounts-with-wholesaler",
        payload,
      );
      message.success(response?.data?.message);
      setEditWholeSale(false);
      getWholeSalerData();
    } catch (error) {
      console.error("Update failed", error);
      message.error(error?.response?.data?.message);
    } finally {
    }
  };
  const updateGpoContacts = async () => {
    try {
      const account = editableData?.[0];
      const payload = {
        acct_id: account?.acct_id,
        programs: account?.gpos?.programs || [],
        contacts: account?.gpos?.contacts?.map((c) => ({
          name: c?.name,
          title: c?.title,
          email: c?.email,
          phone: c?.phone,
          smsFlag: c?.smsFlag,
        })),
      };
      const response = await axiosInstance.put(
        "api/v2/account/accounts-gpo-ipc",
        payload,
      );
      message.success(response?.data?.message);
      setGpoData();
      setIsEditMode(false);
      getGpoData();
    } catch (error) {
      console.error("Update failed", error);
      message.error(error?.response?.data?.message);
    }
  };

  const hideModal = () => {
    setSearchText("");
    hide();
  };
  const baseData = searchText ? filterData : accountsData;
  const sortedData = [...baseData]?.sort((a, b) => {
    const aSelected = selectedAccounts.includes(a.id);
    const bSelected = selectedAccounts.includes(b.id);

    if (aSelected && !bSelected) return -1;
    if (!aSelected && bSelected) return 1;
    return 0;
  });
  const handleContactChange = (value, field, i, wsIndex, index) => {
    const updated = structuredClone(wholeSalerData);

    updated[i].wholesalers[wsIndex].contacts[index][field] = value;

    setWholeSalerData(updated);
  };
  const handleGpoContactChange = (value, field, accIndex, contactIndex) => {
    const updated = structuredClone(editableData);

    updated[accIndex].gpos.contacts[contactIndex][field] = value;

    setEditableData(updated);
  };

  return (
    <Modal
      style={{ marginTop: "-60px" }}
      title={
        <div
          style={{
            borderBottom: "1px solid #f0f0f0",
            padding: "16px 24px",
            marginLeft: -24,
            marginRight: -24,
            marginTop: -16,
            fontSize: "16px",
            fontWeight: 500,
            color: "#262626",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <span>{isNewRecord ? "Add New Account" : "Edit Account"}</span>
          <Button
            type="text"
            icon={<CloseOutlined />}
            onClick={hideModal}
            style={{ marginRight: -12 }}
          />
        </div>
      }
      open={popupWithScrollViewVisible}
      onCancel={handleCancel}
      width="80%"
      destroyOnClose={true}
      maskClosable={false}
      keyboard={false}
      closeIcon={null}
      footer={
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "8px",
            padding: "16px 0",
          }}
        >
          <Button onClick={handleCancel}>Cancel</Button>
          <Button
            type="primary"
            icon={<SaveOutlined />}
            onClick={() => form.submit()}
          >
            {isNewRecord ? "Create Account" : "Save Changes"}
          </Button>
        </div>
      }
    >
      {/* form */}
      <Form
        form={form}
        labelCol={{
          style: { width: 120, display: "flex", justifyContent: "start" },
        }}
        wrapperCol={{ style: { width: "calc(100% - 120px)" } }}
        layout="horizontal"
        onFinish={handleSubmit}
      >
        <div className="border rounded-lg p-4 bg-gray-100">
          <div
            // style={{
            //   display: "grid",
            //   gridTemplateColumns: "repeat(3, 1fr)",
            //   gap: "16px",
            // }}
            className="form-grid gap-x-7"
          >
            <Form.Item
              name="name"
              label={<span style={{ fontWeight: "bold" }}>Name</span>}
              rules={[{ required: true, message: "Please enter account name" }]}
            >
              <Input
                disabled={!isNewRecord}
                style={{
                  // border: "1px solid var(--Primary-Dark-Blue, #000833)",
                  border: "none",
                  height: "40px",
                  color: "#222",
                }}
                prefix={<BankOutlined />}
                placeholder="Enter account name"
              />
            </Form.Item>
            <Form.Item
              name="address"
              label={<span style={{ fontWeight: "bold" }}>Address</span>}
              rules={[{ required: true, message: "Please enter address" }]}
            >
              <Input.TextArea
                style={{
                  // border: "1px solid var(--Primary-Dark-Blue, #000833)",
                  border: "none",
                  height: "40px",
                  color: "#222",
                }}
                rows={1}
                placeholder="Enter address"
              />
            </Form.Item>

            <Form.Item
              name="phone"
              label={<span style={{ fontWeight: "bold" }}>Phone (Store)</span>}
              rules={[{ required: true, message: "Please enter phone number" }]}
            >
              <Input
                style={{
                  // border: "1px solid var(--Primary-Dark-Blue, #000833)",
                  border: "none",
                  height: "40px",
                  color: "#222",
                }}
                placeholder="Enter phone number"
              />
            </Form.Item>

            <Form.Item
              name="acct_id"
              label={<span style={{ fontWeight: "bold" }}>Account Number</span>}
              rules={[
                { required: true, message: "Please enter account number" },
              ]}
            >
              <Input
                disabled={!isNewRecord}
                style={{
                  // border: "1px solid var(--Primary-Dark-Blue, #000833)",
                  border: "none",
                  height: "40px",
                  color: "#222",
                }}
                placeholder="Enter account number"
              />
            </Form.Item>

            <Form.Item
              name="city"
              label={<span style={{ fontWeight: "bold" }}>City</span>}
              rules={[{ required: true, message: "Please enter city" }]}
            >
              <Input
                style={{
                  // border: "1px solid var(--Primary-Dark-Blue, #000833)",
                  border: "none",
                  height: "40px",
                  color: "#222",
                }}
                prefix={<HomeOutlined />}
                placeholder="Enter city"
              />
            </Form.Item>
            <Form.Item
              name="owner_phone"
              label={<span style={{ fontWeight: "bold" }}>Phone (Owner)</span>}
              rules={[{ required: true, message: "Please enter phone number" }]}
            >
              <Input
                style={{
                  // border: "1px solid var(--Primary-Dark-Blue, #000833)",
                  border: "none",
                  height: "40px",
                  color: "#222",
                }}
                placeholder="Enter phone number"
              />
            </Form.Item>

            <Form.Item
              name="account_type"
              label={<span style={{ fontWeight: "bold" }}>Account Type</span>}
              rules={[
                { required: true, message: "Please select account type" },
              ]}
            >
              <Select
                placeholder="Select account type"
                options={[
                  { value: 0, label: "Select" },
                  { value: 2, label: "LTC" },
                  { value: 1, label: "RETAIL" },
                ]}
                style={{
                  // border: "1px solid var(--Primary-Dark-Blue, #000833)",
                  border: "none",
                  height: "40px",
                  color: "#222",
                  "border-radius": "6px",
                }}
              />
            </Form.Item>

            <Form.Item
              name="state"
              label={<span style={{ fontWeight: "bold" }}>State</span>}
              rules={[{ required: true, message: "Please enter state" }]}
            >
              <Input
                style={{
                  // border: "1px solid var(--Primary-Dark-Blue, #000833)",
                  border: "none",
                  height: "40px",
                  color: "#222",
                }}
                prefix={<GlobalOutlined />}
                placeholder="Enter state"
              />
            </Form.Item>

            <Form.Item
              name="fax"
              label={<span style={{ fontWeight: "bold" }}>Fax</span>}
            >
              <Input
                style={{
                  // border: "1px solid var(--Primary-Dark-Blue, #000833)",
                  border: "none",
                  height: "40px",
                  color: "#222",
                }}
                placeholder="Enter fax number"
              />
            </Form.Item>

            <Form.Item
              name="primary_account_id"
              label={
                <span style={{ fontWeight: "bold" }}>Primary Account</span>
              }
            >
              <Input
                disabled={!isNewRecord}
                style={{
                  // border: "1px solid var(--Primary-Dark-Blue, #000833)",
                  border: "none",
                  height: "40px",
                  color: "#222",
                }}
                placeholder="Enter primary account ID"
              />
            </Form.Item>
            <Form.Item
              name="zip"
              label={<span style={{ fontWeight: "bold" }}>Zip</span>}
              rules={[{ required: true, message: "Please enter zip code" }]}
            >
              <Input
                style={{
                  // border: "1px solid var(--Primary-Dark-Blue, #000833)",
                  border: "none",
                  height: "40px",
                  color: "#222",
                }}
                placeholder="Enter zip code"
              />
            </Form.Item>
            <Form.Item
              name="owner_email"
              label={<span style={{ fontWeight: "bold" }}>Email</span>}
            >
              <Input
                style={{
                  // border: "1px solid var(--Primary-Dark-Blue, #000833)",
                  border: "none",
                  height: "40px",
                  color: "#222",
                }}
                placeholder="Enter Email"
              />
            </Form.Item>
            <Form.Item
              name="ncpdp"
              label={
                <span style={{ fontWeight: "bold", color: "#222" }}>NCPDP</span>
              }
            >
              <Input
                style={{
                  // border: "1px solid var(--Primary-Dark-Blue, #000833)",
                  border: "none",
                  height: "40px",
                  color: "#222",
                }}
                placeholder="Enter NCPDP"
              />
            </Form.Item>

            {/* <Form.Item
              name="rebate_types_id"
              label={<span style={{ fontWeight: "bold" }}>Rebate Type</span>}
              rules={[{ required: true, message: "Please select rebate type" }]}
            >
              <Select
                style={{
                  // border: "1px solid var(--Primary-Dark-Blue, #000833)",
                  border: "none",
                  height: "40px",
                  color: "#222",
                  "border-radius": "6px",
                }}
                placeholder="Select rebate type"
                options={[
                  { value: 0, label: "Select" },
                  { value: 1, label: "GCR" },
                  { value: 2, label: "GPR" },
                ]}
              />
            </Form.Item> */}
            <Form.Item
              name="dea"
              label={<span style={{ fontWeight: "bold" }}>DEA ID</span>}
            >
              <Input
                style={{
                  // border: "1px solid var(--Primary-Dark-Blue, #000833)",
                  border: "none",
                  height: "40px",
                  color: "#222",
                }}
                placeholder="Enter DEA ID"
              />
            </Form.Item>

            <Form.Item
              name="active"
              label={<span style={{ fontWeight: "bold" }}>Status</span>}
              rules={[{ required: true, message: "Please select status" }]}
            >
              <Select
                style={{
                  // border: "1px solid var(--Primary-Dark-Blue, #000833)",
                  border: "none",
                  height: "40px",
                  color: "#222",
                  "border-radius": "6px",
                }}
                placeholder="Select status"
                options={[
                  { value: true, label: "Active" },
                  { value: false, label: "Inactive" },
                ]}
              />
            </Form.Item>
            {/* <Form.Item name="npi" label="NPI">
            <Input
              style={{
                border: "1px solid var(--Primary-Dark-Blue, #000833)",
                height: "40px",
              }}
              placeholder="Enter NPI"
            />
          </Form.Item> */}
          </div>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(3, 1fr)",
              gap: "16px",
            }}
          >
            <Form.Item name="send_email" valuePropName="checked">
              <Checkbox>Send Email</Checkbox>
            </Form.Item>

            <Form.Item name="send_sms" valuePropName="checked">
              <Checkbox>Send SMS</Checkbox>
            </Form.Item>
          </div>
        </div>

        {!isNewRecord && (
          <>
            <div className="my-4 gap-4">
              <div className="w-full mt-4 border rounded-lg overflow-hidden text-sm bg-white">
                <div className="overflow-x-auto form-wrapper">
                  <div className="m-3 min-w-[500px] grid grid-cols-2 gap-x-8 gap-y-2 bg-orange-50  rounded-lg px-4 py-3">
                    <div className="grid grid-cols-[auto_1fr] gap-x-2">
                      <span className="font-semibold text-gray-700">
                        {"Subscription Status"} :
                      </span>
                      <span className="text-gray-900 ml-1">-</span>
                    </div>
                  </div>
                </div>
                {/* <div className="overflow-x-auto form-wrapper">
                  <div className="m-3 min-w-[700px] flex justify-between items-center gap-x-8 gap-y-2  rounded-lg px-4 py-3">
                    <div className="flex justify-center items-center gap-x-2">
                      <span className="font-semibold text-gray-700 bg-blue-50 p-2 rounded-lg">
                        Subscription Status
                      </span>
                    </div>
                  </div>
                </div> */}
                <div className="mx-3 ml-32 md:ml-40 form-wrapper max-w-[860px] mb-3 border bg-blue-50 rounded-lg  overflow-x-auto">
                  <div className="min-w-[400px]">
                    <div className="grid grid-cols-3 gap-2 font-semibold px-3 py-2 border-b bg-blue-100">
                      <div>Feature</div>
                      <div>Status</div>
                      <div>Expiry date</div>
                    </div>
                    {displayData?.map((item, i) => {
                      return (
                        <>
                          <div
                            key={i}
                            className="grid grid-cols-3 gap-2 px-3 py-2 border-b"
                          >
                            <div className="">
                              {editSubsCription ? (
                                <input
                                  className="w-full px-4 py-2 rounded-lg border border-gray-300 
             focus:outline-none focus:ring-0 focus:ring-blue-300 
             focus:border-blue-300 transition duration-200 
             shadow-sm"
                                  value={item?.module_name || ""}
                                  onChange={(e) => {
                                    const updated = [...displayData];
                                    updated[i] = {
                                      ...updated[i],
                                      module_name: e.target.value,
                                    };
                                    setSubsData(updated);
                                  }}
                                />
                              ) : (
                                item?.module_name || "-"
                              )}
                            </div>
                            <div>
                              {" "}
                              {editSubsCription ? (
                                <Checkbox
                                  // type="checkbox"
                                  className="ml-3"
                                  checked={item?.is_active || false}
                                  onChange={(e) => {
                                    const updated = [...displayData];
                                    updated[i] = {
                                      ...updated[i],
                                      is_active: e.target.checked,
                                    };
                                    setSubsData(updated);
                                  }}
                                />
                              ) : item?.is_active ? (
                                "true"
                              ) : (
                                "false"
                              )}
                            </div>
                            <div>
                              {editSubsCription ? (
                                <DatePicker
                                  placeholder="Choose Date"
                                  value={
                                    item?.expiry_date
                                      ? dayjs(item.expiry_date)
                                      : null
                                  }
                                  onChange={(date) => {
                                    const updated = [...displayData];

                                    // if (date) {
                                    //   updated[i].expiry_date = date
                                    //     .startOf("day")
                                    //     .toISOString();
                                    // } else {
                                    //   updated[i].expiry_date = null;
                                    // }
                                    updated[i] = {
                                      ...updated[i],
                                      expiry_date: date
                                        ? date.startOf("day").toISOString()
                                        : null,
                                    };
                                    setSubsData(updated);
                                  }}
                                  format="MM-DD-YYYY"
                                  className="w-full"
                                />
                              ) : !!item?.expiry_date ? (
                                moment(item?.expiry_date).format("MM-DD-YYYY")
                              ) : (
                                "-"
                              )}
                            </div>
                          </div>
                        </>
                      );
                    })}
                  </div>
                </div>
                {/* {subsData?.length > 0 && ( */}
                <div className="flex justify-end px-4 py-3">
                  {!editSubsCription ? (
                    <Button
                      type="button"
                      icon={<EditOutlined />}
                      onClick={() => setEditSubsCription(true)}
                      className="px-4 py-1 bg-blue-600 text-white rounded"
                    >
                      Edit
                    </Button>
                  ) : (
                    <Button
                      type="button"
                      icon={<SaveOutlined />}
                      onClick={() => {
                        UpdateSubscription();
                      }}
                      className="px-4 py-1 bg-blue-600 text-white rounded"
                    >
                      Submit
                    </Button>
                  )}
                </div>
                {/* )} */}
              </div>
            </div>

            <div className="my-4 gap-4">
              <span className="font-semibold">Account Number</span>

              {editableData?.map((item, i) => {
                return (
                  <div className="w-full mt-4 border rounded-lg overflow-hidden text-sm bg-white">
                    <div className="overflow-x-auto form-wrapper">
                      <div className="m-3 min-w-[500px] grid grid-cols-2 gap-x-8 gap-y-2 bg-orange-50  rounded-lg px-4 py-3">
                        <div className="grid grid-cols-[auto_1fr] gap-x-2">
                          <span className="font-semibold text-gray-700">
                            {item?.gpos?.orgType || "GPO"} :
                          </span>
                          <span className="text-gray-900 ml-24">
                            {item?.gpos?.name || "-"} /{" "}
                            {item?.gpos?.code || "-"}
                          </span>
                        </div>

                        <div className="grid grid-cols-[auto_1fr] gap-x-2">
                          <span className="font-semibold text-gray-700">
                            Account Number :
                          </span>
                          <span className="text-gray-900 font-semibold">
                            {item?.acct_id || "-"}
                          </span>
                        </div>
                      </div>
                    </div>

                    <div className="mx-3 max-w-[860px] ml-32 md:ml-40 mb-3 border rounded-lg bg-blue-50 overflow-x-auto form-wrapper">
                      <div className="min-w-[700px]">
                        <div className="grid grid-cols-6 gap-2 font-semibold px-3 py-2 border-b bg-blue-100">
                          <div>Contact</div>
                          <div>Title</div>
                          <div>Name</div>
                          <div>Email</div>
                          <div>Phone</div>
                          <div>SMS Flag</div>
                        </div>
                        {item?.gpos?.contacts?.map((contact, index) => {
                          const contactLabel =
                            index === 0
                              ? "Primary Account"
                              : index === 1
                                ? "Level 1"
                                : "Level 2";

                          return (
                            <div
                              key={index}
                              className="grid grid-cols-6 gap-2 px-3 py-2 border-b items-center"
                            >
                              <div>{contactLabel}</div>
                              <div>
                                {isEditMode ? (
                                  <input
                                    className="w-full px-4 py-2 rounded-lg border border-gray-300 
             focus:outline-none focus:ring-0 focus:ring-blue-300 
             focus:border-blue-300 transition duration-200 
             shadow-sm"
                                    value={contact?.title || ""}
                                    onChange={(e) =>
                                      handleGpoContactChange(
                                        e.target.value,
                                        "title",
                                        i,
                                        index,
                                      )
                                    }
                                  />
                                ) : (
                                  contact?.title || "-"
                                )}
                              </div>

                              {/* NAME */}
                              <div>
                                {isEditMode ? (
                                  <input
                                    className="w-full px-4 py-2 rounded-lg border border-gray-300 
             focus:outline-none focus:ring-0 focus:ring-blue-300 
             focus:border-blue-300 transition duration-200 
             shadow-sm"
                                    value={contact?.name || ""}
                                    onChange={(e) =>
                                      handleGpoContactChange(
                                        e.target.value,
                                        "name",
                                        i,
                                        index,
                                      )
                                    }
                                  />
                                ) : (
                                  contact?.name || "-"
                                )}
                              </div>

                              {/* EMAIL */}
                              <div>
                                {isEditMode ? (
                                  <input
                                    className="w-full px-4 py-2 rounded-lg border border-gray-300 
             focus:outline-none focus:ring-0 focus:ring-blue-300 
             focus:border-blue-300 transition duration-200 
             shadow-sm"
                                    value={contact?.email || ""}
                                    onChange={(e) =>
                                      handleGpoContactChange(
                                        e.target.value,
                                        "email",
                                        i,
                                        index,
                                      )
                                    }
                                  />
                                ) : (
                                  contact?.email || "-"
                                )}
                              </div>

                              {/* PHONE */}
                              <div>
                                {isEditMode ? (
                                  <input
                                    className="w-full px-4 py-2 rounded-lg border border-gray-300 
             focus:outline-none focus:ring-0 focus:ring-blue-300 
             focus:border-blue-300 transition duration-200 
             shadow-sm"
                                    value={contact?.phone || ""}
                                    onChange={(e) =>
                                      handleGpoContactChange(
                                        e.target.value,
                                        "phone",
                                        i,
                                        index,
                                      )
                                    }
                                  />
                                ) : (
                                  contact?.phone || "-"
                                )}
                              </div>

                              {/* SMS FLAG */}
                              <div>
                                {isEditMode ? (
                                  <Checkbox
                                    // type="checkbox"
                                    className="ml-3"
                                    checked={contact?.smsFlag || false}
                                    onChange={(e) =>
                                      handleGpoContactChange(
                                        e.target.checked,
                                        "smsFlag",
                                        i,
                                        index,
                                      )
                                    }
                                  />
                                ) : contact?.smsFlag ? (
                                  "True"
                                ) : (
                                  "False"
                                )}
                              </div>
                              {/* <div>{contact?.title || "-"}</div>
                              <div>{contact?.name || "-"}</div>
                              <div className="text-blue-600 text-[12px] break-all">
                                {contact?.email || "-"}
                              </div>
                              <div>{contact?.phone || "-"}</div>
                              <div>{contact?.smsFlag ? "True" : "False"}</div> */}
                            </div>
                          );
                        })}
                      </div>
                    </div>
                    <div className="flex justify-end px-4 py-3">
                      {!isEditMode ? (
                        <Button
                          type="button"
                          icon={<EditOutlined />}
                          onClick={() => setIsEditMode(true)}
                          className="px-4 py-1 bg-blue-600 text-white rounded"
                        >
                          Edit
                        </Button>
                      ) : (
                        <Button
                          type="button"
                          icon={<SaveOutlined />}
                          onClick={() => {
                            // console.log("Updated Data:", editableData);
                            // setIsEditMode(false);
                            updateGpoContacts();
                          }}
                          className="px-4 py-1 bg-blue-600 text-white rounded"
                        >
                          Submit
                        </Button>
                      )}
                    </div>
                  </div>
                );
              })}

              <div className="w-full mt-4 border rounded-lg overflow-hidden text-sm bg-white">
                {/* ===== GPO + Account Section ===== */}
                {wholeSalerData?.map((item, i) => {
                  return (
                    <>
                      <div className="overflow-x-auto form-wrapper">
                        <div className="m-3 min-w-[700px] flex justify-between items-center gap-x-8 gap-y-2 bg-orange-50  rounded-lg px-4 py-3">
                          <div className="flex justify-center items-center gap-x-2">
                            <span className="font-semibold text-gray-700">
                              Primary Wholeseller :
                            </span>
                            <span className="text-gray-900">
                              {item?.wholesalers[0]?.name || "-"}
                            </span>
                          </div>

                          <div className="flex justify-center items-center gap-x-2">
                            <span className="font-semibold text-gray-700">
                              Account Number :
                            </span>
                            <span className="text-gray-900 font-semibold">
                              {item?.acct_id || "-"}
                            </span>
                          </div>
                          <div className="flex justify-center items-center gap-x-2">
                            <span className="font-semibold text-gray-700">
                              LOCID :
                            </span>
                            <span className="text-gray-900 font-semibold">
                              {item?.loc_id || "-"}
                            </span>
                          </div>
                          <div className="flex justify-center items-center gap-x-2">
                            <span className="font-semibold text-gray-700">
                              EDI Status :
                            </span>
                            <span className="text-gray-900 font-semibold">
                              {item?.ediStatus || "-"}
                            </span>
                          </div>
                          <div className="flex justify-center items-center gap-x-2">
                            <span className="font-semibold text-gray-700">
                              Health Mart :
                            </span>
                            <span className="text-gray-900 font-semibold">
                              {item?.health_mart || "-"}
                            </span>
                            {/* <span className="font-semibold text-gray-700">
                    Health Mart H1/H2
                  </span> */}
                          </div>
                        </div>
                      </div>
                      <div className="mx-3 ml-32 md:ml-40 form-wrapper max-w-[860px] mb-3 border rounded-lg bg-blue-50 overflow-x-auto">
                        <div className="min-w-[700px]">
                          {/* Header */}
                          <div className="grid grid-cols-6 gap-2 font-semibold px-3 py-2 border-b bg-blue-100">
                            <div>Contact</div>
                            <div>Title</div>
                            <div>Name</div>
                            <div>Email</div>
                            <div>Phone</div>
                            <div>SMS Flag</div>
                          </div>

                          {/* Rows */}
                          {item?.wholesalers?.map((wholesaler, wsIndex) =>
                            wholesaler?.contacts?.map((contact, index) => {
                              const contactLabel =
                                index === 0
                                  ? "Primary Account"
                                  : index === 1
                                    ? "Level 1"
                                    : "Level 2";

                              return (
                                <div
                                  key={index}
                                  className="grid grid-cols-6 gap-2 px-3 py-2 border-b items-center"
                                >
                                  <div>{contactLabel}</div>
                                  <div>
                                    {editWholeSale ? (
                                      <input
                                        className="w-full px-4 py-2 rounded-lg border border-gray-300 
             focus:outline-none focus:ring-0 focus:ring-blue-300 
             focus:border-blue-300 transition duration-200 
             shadow-sm"
                                        value={contact?.title || ""}
                                        onChange={(e) =>
                                          handleContactChange(
                                            e.target.value,
                                            "title",
                                            i,
                                            wsIndex,
                                            index,
                                          )
                                        }
                                      />
                                    ) : (
                                      contact?.title || "-"
                                    )}
                                  </div>

                                  {/* NAME */}
                                  <div>
                                    {editWholeSale ? (
                                      <input
                                        className="w-full px-4 py-2 rounded-lg border border-gray-300 
             focus:outline-none focus:ring-0 focus:ring-blue-300 
             focus:border-blue-300 transition duration-200 
             shadow-sm"
                                        value={contact?.name || ""}
                                        onChange={(e) =>
                                          handleContactChange(
                                            e.target.value,
                                            "name",
                                            i,
                                            wsIndex,
                                            index,
                                          )
                                        }
                                      />
                                    ) : (
                                      contact?.name || "-"
                                    )}
                                  </div>

                                  {/* EMAIL */}
                                  <div>
                                    {editWholeSale ? (
                                      <input
                                        className="w-full px-4 py-2 rounded-lg border border-gray-300 
             focus:outline-none focus:ring-0 focus:ring-blue-300 
             focus:border-blue-300 transition duration-200 
             shadow-sm"
                                        value={contact?.email || ""}
                                        onChange={(e) =>
                                          handleContactChange(
                                            e.target.value,
                                            "email",
                                            i,
                                            wsIndex,
                                            index,
                                          )
                                        }
                                      />
                                    ) : (
                                      contact?.email || "-"
                                    )}
                                  </div>

                                  {/* PHONE */}
                                  <div>
                                    {editWholeSale ? (
                                      <input
                                        className="w-full px-4 py-2 rounded-lg border border-gray-300 
             focus:outline-none focus:ring-0 focus:ring-blue-300 
             focus:border-blue-300 transition duration-200 
             shadow-sm"
                                        value={contact?.phone || ""}
                                        onChange={(e) =>
                                          handleContactChange(
                                            e.target.value,
                                            "phone",
                                            i,
                                            wsIndex,
                                            index,
                                          )
                                        }
                                      />
                                    ) : (
                                      contact?.phone || "-"
                                    )}
                                  </div>

                                  {/* SMS FLAG */}
                                  <div>
                                    {editWholeSale ? (
                                      <Checkbox
                                        // type="checkbox"
                                        className="ml-3"
                                        checked={contact?.smsFlag || false}
                                        onChange={(e) =>
                                          handleContactChange(
                                            e.target.checked,
                                            "smsFlag",
                                            i,
                                            wsIndex,
                                            index,
                                          )
                                        }
                                      />
                                    ) : contact?.smsFlag ? (
                                      "True"
                                    ) : (
                                      "False"
                                    )}
                                  </div>
                                  {/* <div>{contact?.title || "-"}</div>
                                  <div>{contact?.name || "-"}</div>
                                  <div className="text-blue-600 text-[12px] break-all">
                                    {contact?.email || "-"}
                                  </div>
                                  <div>{contact?.phone || "-"}</div>
                                  <div>
                                    {contact?.smsFlag ? "True" : "False"}
                                  </div> */}
                                </div>
                              );
                            }),
                          )}
                        </div>
                      </div>
                      <div className="flex justify-end px-4 py-3">
                        {!editWholeSale ? (
                          <Button
                            type="button"
                            icon={<EditOutlined />}
                            onClick={() => setEditWholeSale(true)}
                            className="px-4 py-1 bg-blue-600 text-white rounded"
                          >
                            Edit
                          </Button>
                        ) : (
                          <Button
                            type="button"
                            icon={<SaveOutlined />}
                            onClick={() => {
                              updatePMWholeSaler();
                              // setEditWholeSale(false);
                            }}
                            className="px-4 py-1 bg-blue-600 text-white rounded"
                          >
                            Submit
                          </Button>
                        )}
                      </div>
                    </>
                  );
                })}
              </div>
              <div className="w-full mt-4 border rounded-lg overflow-hidden text-sm bg-white">
                {/* ===== GPO + Account Section ===== */}
                {[1]?.map((item, i) => {
                  return (
                    <>
                      <div className="overflow-x-auto form-wrapper">
                        <div className="m-3 min-w-[700px] flex justify-between items-center gap-x-8 gap-y-2 bg-orange-50  rounded-lg px-4 py-3">
                          <div className="flex justify-center items-center gap-x-2">
                            <span className="font-semibold text-gray-700">
                              Secondary WholeSaler :
                            </span>
                            <span className="text-gray-900">
                              {"IPC WAREHOUSE" || "-"}
                            </span>
                          </div>

                          <div className="flex justify-center items-center gap-x-2">
                            <span className="font-semibold text-gray-700">
                              Account Number :
                            </span>
                            <span className="text-gray-900 font-semibold">
                              {"N/A" || "-"}
                            </span>
                          </div>
                          <div className="flex justify-center items-center gap-x-2">
                            <span className="font-semibold text-gray-700">
                              LOCID :
                            </span>
                            <span className="text-gray-900 font-semibold">
                              {"N/A" || "-"}
                            </span>
                          </div>
                          <div className="flex justify-center items-center gap-x-2">
                            <span className="font-semibold text-gray-700">
                              EDI Status :
                            </span>
                            <span className="text-gray-900 font-semibold">
                              {"Active" || "-"}
                            </span>
                          </div>
                          <div className="flex justify-center items-center gap-x-2">
                            <span className="font-semibold text-gray-700">
                              Health Mart :
                            </span>
                            <span className="text-gray-900 font-semibold">
                              {"-"}
                            </span>
                            {/* <span className="font-semibold text-gray-700">
                    Health Mart H1/H2
                  </span> */}
                          </div>
                        </div>
                      </div>
                      <div className="mx-3 ml-32 md:ml-40 form-wrapper max-w-[860px] mb-3 border rounded-lg bg-blue-50 overflow-x-auto">
                        <div className="min-w-[700px]">
                          {/* Header */}
                          <div className="grid grid-cols-6 gap-2 font-semibold px-3 py-2 border-b bg-blue-100">
                            <div>Contact</div>
                            <div>Title</div>
                            <div>Name</div>
                            <div>Email</div>
                            <div>Phone</div>
                            <div>SMS Flag</div>
                          </div>

                          {/* Rows */}
                          {[1]?.map((wholesaler) =>
                            [1, 2, 3]?.map((contact, index) => {
                              const contactLabel =
                                index === 0
                                  ? "Primary Account"
                                  : index === 1
                                    ? "Level 1"
                                    : "Level 2";

                              return (
                                <div
                                  key={index}
                                  className="grid grid-cols-6 gap-2 px-3 py-2 border-b"
                                >
                                  <div>{contactLabel}</div>
                                  <div>{"-"}</div>
                                  <div>{"-"}</div>
                                  <div className="text-blue-600 text-[12px] break-all">
                                    {"-"}
                                  </div>
                                  <div>{"-"}</div>
                                  <div>{"-"}</div>
                                </div>
                              );
                            }),
                          )}
                        </div>
                      </div>
                    </>
                  );
                })}
              </div>
              <div className="w-full mt-4 border rounded-lg overflow-hidden text-sm bg-white">
                {/* ===== GPO + Account Section ===== */}
                {[1]?.map((item, i) => {
                  return (
                    <>
                      <div className="overflow-x-auto form-wrapper">
                        <div className="m-3 min-w-[700px] flex justify-between items-center gap-x-8 gap-y-2 bg-orange-50  rounded-lg px-4 py-3">
                          <div className="flex justify-center items-center gap-x-2">
                            <span className="font-semibold text-gray-700">
                              Secondary WholeSaler :
                            </span>
                            <span className="text-gray-900">
                              {"Masters" || "-"}
                            </span>
                          </div>

                          <div className="flex justify-center items-center gap-x-2">
                            <span className="font-semibold text-gray-700">
                              Account Number :
                            </span>
                            <span className="text-gray-900 font-semibold">
                              {"N/A" || "-"}
                            </span>
                          </div>
                          <div className="flex justify-center items-center gap-x-2">
                            <span className="font-semibold text-gray-700">
                              LOCID :
                            </span>
                            <span className="text-gray-900 font-semibold">
                              {"N/A" || "-"}
                            </span>
                          </div>
                          <div className="flex justify-center items-center gap-x-2">
                            <span className="font-semibold text-gray-700">
                              EDI Status :
                            </span>
                            <span className="text-gray-900 font-semibold">
                              {"Active" || "-"}
                            </span>
                          </div>
                          <div className="flex justify-center items-center gap-x-2">
                            <span className="font-semibold text-gray-700">
                              Health Mart :
                            </span>
                            <span className="text-gray-900 font-semibold">
                              {"-"}
                            </span>
                            {/* <span className="font-semibold text-gray-700">
                    Health Mart H1/H2
                  </span> */}
                          </div>
                        </div>
                      </div>
                      <div className="mx-3 ml-32 md:ml-40 form-wrapper max-w-[860px] mb-3 border rounded-lg bg-blue-50 overflow-x-auto">
                        <div className="min-w-[700px]">
                          {/* Header */}
                          <div className="grid grid-cols-6 gap-2 font-semibold px-3 py-2 border-b bg-blue-100">
                            <div>Contact</div>
                            <div>Title</div>
                            <div>Name</div>
                            <div>Email</div>
                            <div>Phone</div>
                            <div>SMS Flag</div>
                          </div>

                          {/* Rows */}
                          {[1]?.map((wholesaler) =>
                            [1, 2, 3]?.map((contact, index) => {
                              const contactLabel =
                                index === 0
                                  ? "Primary Account"
                                  : index === 1
                                    ? "Level 1"
                                    : "Level 2";

                              return (
                                <div
                                  key={index}
                                  className="grid grid-cols-6 gap-2 px-3 py-2 border-b"
                                >
                                  <div>{contactLabel}</div>
                                  <div>{"-"}</div>
                                  <div>{"-"}</div>
                                  <div className="text-blue-600 text-[12px] break-all">
                                    {"-"}
                                  </div>
                                  <div>{"-"}</div>
                                  <div>{"-"}</div>
                                </div>
                              );
                            }),
                          )}
                        </div>
                      </div>
                    </>
                  );
                })}
              </div>
              <div className="w-full mt-4 border rounded-lg overflow-hidden text-sm bg-white">
                {/* ===== GPO + Account Section ===== */}
                {[1]?.map((item, i) => {
                  return (
                    <>
                      <div className="overflow-x-auto form-wrapper">
                        <div className="m-3 min-w-[700px] flex justify-between items-center gap-x-8 gap-y-2 bg-orange-50  rounded-lg px-4 py-3">
                          <div className="flex justify-center items-center gap-x-2">
                            <span className="font-semibold text-gray-700">
                              Secondary WholeSaler :
                            </span>
                            <span className="text-gray-900">{"3" || "-"}</span>
                          </div>

                          <div className="flex justify-center items-center gap-x-2">
                            <span className="font-semibold text-gray-700">
                              Account Number :
                            </span>
                            <span className="text-gray-900 font-semibold">
                              {"N/A" || "-"}
                            </span>
                          </div>
                          <div className="flex justify-center items-center gap-x-2">
                            <span className="font-semibold text-gray-700">
                              LOCID :
                            </span>
                            <span className="text-gray-900 font-semibold">
                              {"N/A" || "-"}
                            </span>
                          </div>
                          <div className="flex justify-center items-center gap-x-2">
                            <span className="font-semibold text-gray-700">
                              EDI Status :
                            </span>
                            <span className="text-gray-900 font-semibold">
                              {"Active" || "-"}
                            </span>
                          </div>
                          <div className="flex justify-center items-center gap-x-2">
                            <span className="font-semibold text-gray-700">
                              Health Mart :
                            </span>
                            <span className="text-gray-900 font-semibold">
                              {"-"}
                            </span>
                            {/* <span className="font-semibold text-gray-700">
                    Health Mart H1/H2
                  </span> */}
                          </div>
                        </div>
                      </div>
                      <div className="mx-3 ml-32 md:ml-40 form-wrapper max-w-[860px] mb-3 border rounded-lg bg-blue-50 overflow-x-auto">
                        <div className="min-w-[700px]">
                          {/* Header */}
                          <div className="grid grid-cols-6 gap-2 font-semibold px-3 py-2 border-b bg-blue-100">
                            <div>Contact</div>
                            <div>Title</div>
                            <div>Name</div>
                            <div>Email</div>
                            <div>Phone</div>
                            <div>SMS Flag</div>
                          </div>

                          {/* Rows */}
                          {[1]?.map((wholesaler) =>
                            [1, 2, 3]?.map((contact, index) => {
                              const contactLabel =
                                index === 0
                                  ? "Primary Account"
                                  : index === 1
                                    ? "Level 1"
                                    : "Level 2";

                              return (
                                <div
                                  key={index}
                                  className="grid grid-cols-6 gap-2 px-3 py-2 border-b"
                                >
                                  <div>{contactLabel}</div>
                                  <div>{"-"}</div>
                                  <div>{"-"}</div>
                                  <div className="text-blue-600 text-[12px] break-all">
                                    {"-"}
                                  </div>
                                  <div>{"-"}</div>
                                  <div>{"-"}</div>
                                </div>
                              );
                            }),
                          )}
                        </div>
                      </div>
                    </>
                  );
                })}
              </div>
            </div>
          </>
        )}
        {/* table  */}
        <div style={{ marginTop: "24px" }}>
          <Space
            className="flex flex-row justify-between items-center"
            style={
              {
                // marginBottom: "16px",
                //   display: "flex",
                //   justifyContent: "space-between",
              }
            }
          >
            <div className="">
              <h2>Accounts</h2>
            </div>
            <div className="flex gap-2">
              <Input
                placeholder="Search by Name or Email"
                allowClear
                onChange={(e) => handleSearch(e.target.value)}
                // style={{ width: 400 }}
                className="w-full md:w-[400px]"
                prefix={<SearchOutlined />}
              />
              {data && (
                <Tooltip title={editMode ? "Save Changes" : "Edit Accounts"}>
                  <Button
                    icon={editMode ? <SaveOutlined /> : <EditOutlined />}
                    onClick={() =>
                      editMode ? handleSaveAccounts() : setEditMode(true)
                    }
                  >
                    {editMode ? "Save" : "Edit"}
                  </Button>
                </Tooltip>
              )}
            </div>
          </Space>

          <Table
            loading={loading}
            columns={accountColumns}
            // Always show all accounts in edit mode
            dataSource={
              sortedData
              // !searchText
              //   ? accountsData
              //   // : !editMode
              //   : filterData
            }
            rowSelection={
              editMode
                ? {
                    type: "checkbox",
                    selectedRowKeys: selectedAccounts,
                    onChange: (keys) => setSelectedAccounts(keys),
                    // Preserve selections when filtering
                    preserveSelectedRowKeys: true,
                    // Default checked state based on mapped accounts
                    defaultSelectedRowKeys: userMappedAccounts.map(
                      (user) => user.id,
                    ),
                  }
                : null
            }
            rowClassName={(record) => {
              return (
                editMode
                  ? selectedAccounts.includes(record.id) // Highlight selected rows in edit mode
                  : userMappedAccounts.some((acc) => acc.id === record.id)
              )
                ? // Highlight mapped users in view mode
                  "mapped-user-row"
                : "";
            }}
            // rowClassName={(record) => {
            //   // Change from acct_id to id here
            //   return userMappedAccounts.some((acc) => acc.id === record.id)
            //     ? "ant-table-row-selected"
            //     : "";
            // }}
            size="small"
            // scroll={{ x: true, y: "calc(100vh - 600px)" }}
            scroll={{ y: 400 }}
            // Change to use ID as row key instead of email
            rowKey={(record) => record.id}
          />

          <style jsx>{`
            .mapped-user-row {
              background-color: #e6f7ff !important;
            }
            .mapped-user-row:hover {
              background-color: #bae7ff !important;
            }
          `}</style>
        </div>
      </Form>
    </Modal>
  );
};

export default AccountPopup;
